import { Reducer } from 'react';
import { HttpViewState } from 'store/analytics/ui/analyticsUiTypes';

import { initialHttpViewState } from '../common/initialValues';
import {
  HttpCallsActionTypes,
  SELECT_HTTP_CALLS_DETAIL_TAB,
  SELECT_HTTP_CALLS_VIEW_TRIGGER,
  SET_HTTP_CALLS_ACTIVE_PAGE,
  SET_HTTP_CALLS_PAGE_SIZE,
  SET_HTTP_CALLS_SEARCH_KEYWORD,
} from './httpCallsActionTypes';

export const httpCallsViewReducer: Reducer<HttpViewState, HttpCallsActionTypes> = (
  state = initialHttpViewState,
  action,
): HttpViewState => {
  switch (action.type) {
    case SET_HTTP_CALLS_ACTIVE_PAGE:
      return { ...state, activePage: action.payload };
    case SET_HTTP_CALLS_PAGE_SIZE:
      return { ...state, pageSize: action.payload };
    case SELECT_HTTP_CALLS_VIEW_TRIGGER:
      return { ...state, selectedHttpRequest: action.payload };
    case SELECT_HTTP_CALLS_DETAIL_TAB:
      return { ...state, selectedViewTab: action.payload };
    case SET_HTTP_CALLS_SEARCH_KEYWORD:
      return { ...state, searchKeyword: action.payload };
    default:
      return state;
  }
};
